var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "80%",
      "scrollable": true,
      "name": "client-medicament",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "lab-results-prescription-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Vypsání receptu pro " + _vm._s(_vm.propClient.full_name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('client-medicament', {
    attrs: {
      "prop-client-id": _vm.propClient.id
    }
  })], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5842cba","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Modal/ClientMedicament.vue
// module id = 735
// module chunks = 0